import React, {Component} from 'react';
import PropTypes from 'prop-types';

/*global google*/

/*eslint no-undef: "error"*/

class PreferenceStreetMap extends Component {
    componentDidMount() {
        const props = this.props;

        let lat = this.props.lat || 35.282752;
        let lng = this.props.lng || -120.659616;
        const radius = this.props.radius || 300;

        let map = new google.maps.Map(this.refs.mapContainer, {
            center: {lat: lat, lng: lng},
            scrollwheel: false,
            mapTypeControl: false,
            zoom: 15
        });
        let locationCircle = new google.maps.Circle({
            strokeColor: '#00ade9',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#00ade9',
            fillOpacity: 0.35,
            map: map,
            editable: this.props.is_coordinator,
            center: {lat: lat, lng: lng},
            radius: radius
        });

        map.fitBounds(locationCircle.getBounds());

        const setCoords = (pos) => {
            lat = pos.coords.latitude;
            lng = pos.coords.longitude;
            map.setCenter(new google.maps.LatLng(lat, lng));
        };

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(setCoords);
        }

        google.maps.event.addListener(locationCircle, 'radius_changed', function () {
            props.onUpdate({
                lat: locationCircle.getCenter().lat(),
                lng: locationCircle.getCenter().lng(),
                radius: locationCircle.getRadius()
            });
        });

        google.maps.event.addListener(locationCircle, 'center_changed', function () {
            // map.setCenter(new google.maps.LatLng(locationCircle.getCenter().lat(), locationCircle.getCenter().lng()));
            props.onUpdate({
                lat: locationCircle.getCenter().lat(),
                lng: locationCircle.getCenter().lng(),
                radius: locationCircle.getRadius()
            });
        });

        google.maps.event.addListener(locationCircle, 'dragend', function () {
            props.onUpdate({
                lat: locationCircle.getCenter().lat(),
                lng: locationCircle.getCenter().lng(),
                radius: locationCircle.getRadius()
            });
        });
    }

    render() {
        return (
            <div style={{height: this.props.height, width: this.props.width, ...this.props.style}} ref="mapContainer"/>
        );
    }
}

PreferenceStreetMap.propTypes = {
    onUpdate: PropTypes.func
};

PreferenceStreetMap.defaultProps = {width: "100%"};

export default PreferenceStreetMap;


// WEBPACK FOOTER //
// ./src/components/media/maps/PreferenceStreetMap.js